/* tslint:disable */
import {Directive, OnInit} from '@angular/core';
import {OlMapService} from './ol-map.service';

@Directive({
  selector: '[appOlMap]'
})
export class OlMapDirective implements OnInit {

  map;

  constructor(private olMapService: OlMapService) {}

  ngOnInit(): void {
    this.map = this.olMapService.initializingMap();
  }


}
